import React from 'react';
import { MAX_SUPPLIERS_IN_TABLE } from './LifeCycleAnalyticsConstants';

export type LifeCycleSupplierTableColumnsArgs = {
	filteredSupplierPerformanceLength: number;
	renderSupplierLink: (text: any, record: any) => React.ReactNode;
	renderWoCount: (value: any) => any;
	sortWoCount: (a: any, b: any) => number;
	sortAvgResponseTime: (a: any, b: any) => number;
	renderDurationColumn: (value: any) => any;
	sortAvgResolutionTime: (a: any, b: any) => number;
	sortFirstTimeFixRate: (a: any, b: any) => number;
	renderFirstTimeFixRate: (value: any) => any;
};

export function buildLifeCycleSupplierTableColumns({
	filteredSupplierPerformanceLength,
	renderSupplierLink,
	renderWoCount,
	sortWoCount,
	sortAvgResponseTime,
	renderDurationColumn,
	sortAvgResolutionTime,
	sortFirstTimeFixRate,
	renderFirstTimeFixRate,
}: LifeCycleSupplierTableColumnsArgs) {
	return [
		{
			title: `Suppliers (${Math.min(filteredSupplierPerformanceLength, MAX_SUPPLIERS_IN_TABLE)})`,
			dataIndex: 'supplierFacilityName',
			key: 'supplierFacilityName',
			width: '30%',
			render: renderSupplierLink,
			onCell: () => ({ style: { padding: 16 } }),
			onHeaderCell: () => ({ style: { padding: 16 } }),
		},
		{
			title: 'WOs',
			dataIndex: 'woCount',
			key: 'woCount',
			sorter: sortWoCount,
			render: renderWoCount,
		},
		{
			title: 'Response time [Avg]',
			dataIndex: 'avgResponseTimeSeconds',
			key: 'avgResponseTimeSeconds',
			sorter: sortAvgResponseTime,
			render: renderDurationColumn,
		},
		{
			title: 'Resolution time [Avg]',
			dataIndex: 'avgResolutionTimeSeconds',
			key: 'avgResolutionTimeSeconds',
			sorter: sortAvgResolutionTime,
			render: renderDurationColumn,
		},
		{
			title: 'First time fix',
			dataIndex: 'firstTimeFixRate',
			key: 'firstTimeFixRate',
			sorter: sortFirstTimeFixRate,
			render: renderFirstTimeFixRate,
		},
	];
}
